import React, {useEffect, useState} from "react";
import {useAppData} from "../../context/Contexts";
import Step3New from "../Step3New";
import VehicleConfigurator from "../VehicleConfigurator";
import VideoPlayer from "../VideoPlayer";
import DevVideoDebug from "../DevVideoDebug";


const MainStepNewScsBiz2: React.FC = (props) => {
    const {currentAppData} = useAppData();
    const [incompatible, setIncompatible] = useState<boolean>(false);

    useEffect(() => {
        setIncompatible((typeof currentAppData?.check !== 'undefined'
            && (currentAppData?.check?.compatibility === 'N' || currentAppData?.check?.compatibility === 'A')
            && currentAppData?.check?.compatibility_custom === 'N'
            && (currentAppData?.step ?? 0) > 1));
    }, [currentAppData]);

    return (<>
        {!incompatible ? (<>
            <Step3New id={props.id} stepNumber={2}/>
            {window.scs_vehicle_configurator && <VehicleConfigurator stepNumber={3} />}
            <VideoPlayer />
            <DevVideoDebug />
        </>) : ''}
    </>);
};

export default MainStepNewScsBiz2;